import { trigger, transition, style, animate } from '@angular/animations';

export const fadeTextAnimation = trigger('fadeText', [
    transition(':enter', [
        style({ opacity: 0 }),
        animate('200ms ease-in', style({ opacity: 1 }))
    ]),
    transition(':leave', [
        animate('200ms ease-out', style({ opacity: 0 }))
    ])
]);